import React from "react";
import { Button } from "../../../components/ui";
import { plusIcon } from "../../../assets/Icons/icons";
import { strings } from "../../../strings/strings";

const AddButton = ({ onOptionSelect, showOptions, setShowOptions, variant = "default", className = "" }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    setShowOptions((prev) => !prev);
  };

  const handleOptionClick = (mode, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    onOptionSelect(mode, e);
    setShowOptions(false);
  };

  const getDropdownPosition = () => {
    if (variant === "header") {
      return "absolute top-full left-0 sm:left-auto right-0 mt-2";
    } else if (variant === "empty") {
      return "absolute top-full left-1/2 transform -translate-x-1/2 mt-2";
    } else {
      return "absolute top-full right-0 mt-2";
    }
  };

  return (
    <div className="relative add-options-container">
      <Button
        onClick={handleClick}
        className={className}
        size={variant === "empty" ? "lg" : variant === "table" ? "lg" : undefined}
      >
        <img src={plusIcon} alt={strings.add} className="h-5 w-5 inline-block mr-2" />
        <span>{strings.addStaticString}</span>
      </Button>
      {showOptions && (
        <div className={`${getDropdownPosition()} w-56 bg-white border border-gray-200 rounded-xl shadow-2xl z-50 overflow-hidden`}>
          <button
            onClick={(e) => handleOptionClick("single", e)}
            className="block w-full text-left px-5 py-3 hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 transition-colors duration-150 font-medium text-secondary hover:text-primary"
          >
            <span className="text-primary mr-2">+</span>{strings.addsingleString}
          </button>
          <div className="border-t border-gray-100"></div>
          <button
            onClick={(e) => handleOptionClick("json", e)}
            className="block w-full text-left px-5 py-3 hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 transition-colors duration-150 font-medium text-secondary hover:text-primary"
          >
            <span className="text-primary mr-2">+</span>{strings.addviaJSON}
          </button>
        </div>
      )}
    </div>
  );
};

export default AddButton;

